// frontend/src/components/screens/NoSeat.tsx
// Shown only when the server would not open an anonymous session. The site
// is fully public (owner decision, 2026-09-27): everyone who follows the link
// gets in, and there is no code or email sign-in anywhere in the player UI.
// So this screen asks for nothing. It covers two cases:
//   - the per-IP anonymous-session rate limit (429), which says how long to
//     wait (from Retry-After) and offers to try again;
//   - the emergency REQUIRE_INVITE gate (403), which says the Court is closed
//     to new visitors for now.
import { useAuth } from '../../hooks/useAuth';
import { ANON_RATE_LIMITED } from '../../contexts/AuthContext';
import { waitPhrase } from '../../lib/api';
import PoliceNotice from '../chrome/PoliceNotice';

export default function NoSeat() {
  const { error, anonRetryAfter } = useAuth();
  const rateLimited = error === ANON_RATE_LIMITED;

  return (
    <main className="full-screen-min-h" aria-label="SCOTUS the Nine">
      <PoliceNotice
        title="SCOTUS the Nine"
        actions={<button type="button" className="pb wood" onClick={() => window.location.reload()}>Try again</button>}
      >
        <p role="status" data-testid={rateLimited ? 'anon-rate-limited' : 'court-closed'}>
          {rateLimited
            ? `Too many new visitors came from your network just now, so the Court could not open a seat for you. Try again ${waitPhrase(anonRetryAfter ?? null)}.`
            : 'The Court is closed to new visitors right now. Please come back later.'}
        </p>
      </PoliceNotice>
    </main>
  );
}
